import React, { PureComponent } from "react";
import { MasonryInfiniteGrid } from "@egjs/react-infinitegrid";
import { ShowCenterSpinner } from "./statelessView";
import { Flex, Spinner } from "@chakra-ui/react";

class TLDRInfiniteGalleryGridLayout extends PureComponent {
  constructor(props) {
    super(props);
    this.groupKey = 0;
    this.gridRef = React.createRef();
  }

  render() {
    const { children, hasMore, className, loaded, margin, height, selectedTab } = this.props;
    return (
      <>
        {children.length > 0 && (
          <Flex
            className="grid-gallery"
            h={selectedTab == "resize" ? "0px" : height}           //required to make panel scrolllable
            direction="column"
            grow={1}
          >
            <MasonryInfiniteGrid
              ref={(node) => (this.gridRef = node)}
              className={`gridlayout gridlayout-container ${className}`}
              groupBy={(item) => item.props["data-grid-groupkey"]}
              loading={
                <div className="loading">
                  <Spinner color="brand.primary" size="xl" />
                </div>
              }
              container
              useFit
              useRecycle
              horizontal={false}
              threshold={500}
              gap={margin ? margin : 15}
              align="start"
              onRenderComplete={(e) => {}}
              onChangeScroll={(e) => {}}
              onRequestAppend={(e) => {
                if (!hasMore) {
                  e.stop();
                  return;
                }
                this.groupKey =
                  (typeof e.groupKey === "undefined" ? 0 : +e.groupKey || 0) +
                  1;
                e.wait();
                this.loadNextPage(e, this.groupKey);
              }}
              onContentError={(error) => {
                console.error(error);
              }}
            >
              {children}
            </MasonryInfiniteGrid>

            {children.length === 0 && hasMore && (
              <ShowCenterSpinner loaded={loaded}></ShowCenterSpinner>
            )}
          </Flex>
        )}
      </>
    );
  }

  componentWillUnmount() {}

  componentDidMount() {
    // Do nothing
    // this.loadNextPage(0);
  }

  componentDidUpdate(prevProps, prevState) {}

  loadNextPage = (e, groupKey) => {
    // Execute call from Parent components
    setTimeout(() => {
      e.ready();
      this.props.loadPage(groupKey);
    }, 1000);
  };
}

TLDRInfiniteGalleryGridLayout.propTypes = {};
TLDRInfiniteGalleryGridLayout.defaultProps = {
  className: "",
  height: 550,
};

export default TLDRInfiniteGalleryGridLayout;
